import { useState } from 'react'
import { customerData, CustomerInvoiceData } from '../../utilities/CustomerData'
import { apiURL } from '../../utilities/URLs'
import DashboardTOSModal from '../Dashboard/DashboardScreens/DashboardTOS/DashboardTOS'
import { useNavigate } from 'react-router-dom'
import { GenerateInvoicePostPaid, GenerateInvoicePrePaid } from './PaymentModals'
import { refreshAccessToken } from '../../utilities/extensions'
import posthog from 'posthog-js'

export function RefundCalculatedWindow() {
  const navigate = useNavigate()

  const [showTOS, setShowTOS] = useState(false)
  const [customerStageTreeIndex, setCustomerStageTreeIndex] = useState(customerData.customerStageHistory.find(stage => stage.currentStage === true).customerStageTreeIndex)
  const [generatingInvoice, setGeneratingInvoice] = useState(false)
  const [showPostPaidInvoice, setShowPostPaidInvoice] = useState(false)
  const [showPrePaidInvoice, setShowPrePaidInvoice] = useState(false)
  const [tosCustomerFee, setTOSCustomerFee] = useState(0.15)
  const [tosOptionClicked, setTOSOptionClicked] = useState(0)

  const handledSignedAndSetFee = async () => {
    await handleSignedTOS(tosCustomerFee, tosOptionClicked)
  }

  const handleShowInvoiceModal = () => {
    navigate('/refundCalculated')
  }

  const handleSignedTOS = async (customerFee, optionClicked) => {
    setShowTOS(false)
    setGeneratingInvoice(true)

    const formData = new FormData()
    formData.append('customerInvoiceInfo', JSON.stringify({
      zohoId: customerData.customerLeadData.leadId,
      customerId: customerData.customerLeadData.leadContact.contactId,
      invoiceId: customerData.customerInvoiceData.invoiceId,
      customerName: customerData.customerLeadData.leadContact.contactName,
      customerEmail: customerData.customerLeadData.leadContact.contactEmail,
      customerRefundAmount: customerData.customerLeadData.leadAmount,
      customerFee: customerFee,
      invoicePaymentType: optionClicked === 1 ? 'Post-Paid' : 'Pre-Paid',
      currentInvoiceLink: customerData.customerInvoiceData.invoiceLinkURL
    }))

    const generateInvoiceResponse = await fetch(`${apiURL}/api/generateInvoice`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const generateInvoiceData = await generateInvoiceResponse.json()
    setGeneratingInvoice(false)

    if (generateInvoiceData.response.error) {
      if (generateInvoiceData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleSignedTOS(customerFee, optionClicked) : navigate('/', { state: { expired: true } })
      } else
        console.error(generateInvoiceData.response.error)
    } else {
      posthog.stopSessionRecording()
      customerData.customerInvoiceData = new CustomerInvoiceData(generateInvoiceData.response.invoiceData.invoiceInfo)

      if (customerData.customerLeadData.leadId === '6023320000030939004')
        navigate('/shippoRates', { state: { isPostPaid: optionClicked === 1 ? true : false } })
      else
        navigate(optionClicked === 1 ? '/addPaymentMethod' : '/paymentPortal')
    }
  }

  return (
    <>
      <div className='lg:w-full w-11/12 flex flex-col gap-4'>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
          <div className='w-full flex flex-col items-center'>
            <div className='w-full flex flex-col items-center gap-8 mt-4'>
              <button 
                onClick={handleShowInvoiceModal} 
                className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                  <div className='flex flex-col items-center gap-2'>
                    <p className='text-2xl'>Get My Refund <span className='underline italic'>NOW!</span></p>
                    <p className='text-lg'>Click Here</p>
                  </div>
              </button>
              {customerData.customerLeadData.leadStage.leadStageId === '034d6ab6-f2dc-47b9-a420-63df42b87381' ? (
                <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
                  <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
                  <iframe className='w-full aspect-video' src="https://www.loom.com/embed/2b9e5caa8ace45e2b0862560683d17eb?sid=076a109a-457e-441d-a4ec-f9d589cbdc7d&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              ) : (
                customerData.customerSoftQualify.qualifies ? (
                  <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
                    <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
                    <iframe className='w-full aspect-video' src="https://www.loom.com/embed/2375d4814646489b8637487971ad02e5?sid=d308a262-ad40-4cb2-aa23-905bfe4cb53e&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </div>
                ) : (
                  <div className='flex flex-col items-center gap-4 bg-white p-4 rounded-md shadow-md w-full'>
                    <p className='text-sm text-center text-black'>See QUICK Video Below For Instructions on NEXT STEPS!</p>
                    <iframe className='w-full aspect-video' src="https://www.loom.com/embed/6e451ecadb5e4aceac622bfbcc1b1d24?sid=f2725b8a-e2fb-4fda-bae9-64675515fbcf&hideEmbedTopBar=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
          <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
          <p className='font-bold text-xl text-[#646464]'>Click <span onClick={handleShowInvoiceModal} className='text-[#FF8C00] underline cursor-pointer'>HERE</span> to complete your refund.</p>
        </div>
      </div>
      <GenerateInvoicePostPaid
        isOpen={showPostPaidInvoice}
        setIsOpen={setShowPostPaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        setTOSOptionClicked={setTOSOptionClicked}
        generatingInvoice={generatingInvoice}
      />
      <GenerateInvoicePrePaid
        isOpen={showPrePaidInvoice}
        setIsOpen={setShowPrePaidInvoice}
        setShowTOS={setShowTOS}
        handleSignedTOS={handleSignedTOS}
        setTOSCustomerFee={setTOSCustomerFee}
        setTOSOptionClicked={setTOSOptionClicked}
        generatingInvoice={generatingInvoice}
      />
      <DashboardTOSModal
        isOpen={showTOS}
        setIsOpen={setShowTOS}
        onClose={handledSignedAndSetFee}
      />
    </>
  )
}